// Utility functions for safe clipboard operations with fallbacks
export const safeCopyToClipboard = async (data) => {
  try {
    const jsonData = JSON.stringify(data);

    // Try Clipboard API first
    await navigator.clipboard.writeText(jsonData);
    console.log("Copied to system clipboard");

    // Also update localStorage for fallback across tabs
    localStorage.setItem("layout-editor-clipboard", jsonData);
  } catch (error) {
    console.warn("Clipboard API failed — using localStorage fallback:", error);
    // Fallback to localStorage if Clipboard API fails
    localStorage.setItem("layout-editor-clipboard", JSON.stringify(data));
  }
};

export const safePasteFromClipboard = async () => {
  try {
    const text = await navigator.clipboard.readText();

    // Verify it’s valid JSON and matches expected format
    const parsed = JSON.parse(text);
    if (parsed && parsed.objectType) {
      console.log("Pasted from system clipboard");
      return parsed;
    } else {
      throw new Error("Invalid clipboard data format");
    }
  } catch (error) {
    console.warn("Clipboard read failed — using localStorage fallback:", error);
    const fallback = localStorage.getItem("layout-editor-clipboard");
    if (!fallback) return null;
    try {
      return JSON.parse(fallback);
    } catch {
      return null;
    }
  }
};
